export default __webpack_public_path__ + "static/media/dwg.60357cb1.png";